import React, { ReactNode, useState } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

export interface DropdownMenuItemInterface {
  label: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

interface DropdownMenuProps {
  button?: ReactNode;
  items: DropdownMenuItemInterface[];
  disableScrollLock?: boolean;
  buttonProps?: Partial<Omit<ButtonProps, 'onClick'>>;
}

function DropdownMenu({ button, items, disableScrollLock, buttonProps }: DropdownMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <span
        onClick={handleClick}
        aria-hidden='true'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        {button ?? (
          <Button sx={{ border: 'none' }} onClick={handleClick} variant='text' {...buttonProps}>
            <MoreVertIcon />
          </Button>
        )}
      </span>

      <Menu
        id='basic-menu'
        keepMounted
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={disableScrollLock}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {items.map((item, i) => (
          <MenuItem key={i} onClick={item.onClick} disabled={item.disabled}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default DropdownMenu;
